module.exports = __webpack_public_path__ + "static/media/ic_proyectos_aereo_pin.5e52e473.svg";